<template>
  <div>
    <div class="table-wrapper">
      <div class="query-box">
        <Form
          ref="formInline"
          :model="formInline"
          inline
          :label-width="100"
          label-position="right"
        >
          <div class="search-right-wrapper">
            <Row>
              <Button style="float: left" @click="showModal" type="primary"
                >新增用户</Button
              >

              <!-- <FormItem label="用户类型：" prop="type">
                            <RadioGroup v-model="formInline.userType" @on-change="handleQuery">
                                <Radio v-for="(item,index) in common.userTypes" :label="item.value" :key="index">{{item.label}}</Radio>
                            </RadioGroup>
                        </FormItem> -->
            <div style="margin-left:auto;text-align:right;">
              <FormItem
                label="行政区划:"
                prop="areaCode"
                style="width: 286px; text-align: left"
              >
                <!-- <Select
                  v-model="formInline.tenantAreaCode"
                  style="width: 186px;"
                  @on-change="areaChange"
                >
                  <Option
                    v-for="item in area"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select> -->
                <place-select
                  v-model="formInline.areaCode"
                  v-if="!showSelect"
                ></place-select>
                <Input v-model="areaName" v-else disabled></Input>
              </FormItem>

              <FormItem
                label="登录用户名"
                prop="accountName"
                style="width: 286px; text-align: left"
              >
                <Input
                  v-model="formInline.accountName"
                  @on-search="handleQuery"
                  placeholder="请输入登录用户名"
                  clearable
                ></Input>
                <Input style="display: none"></Input>
              </FormItem>
              <FormItem
                label="姓名:"
                prop="userName"
                style="width: 286px; text-align: left"
              >
                <Input
                  v-model="formInline.userName"
                  @on-search="handleQuery"
                  placeholder="请输入姓名"
                  clearable
                ></Input>
                <Input style="display: none"></Input>
              </FormItem>
          
                <FormItem
                  class="formLineList"
                  label="状态:"
                  prop="isUse"
                  style="width:286px;text-align:left;"
                >
                  <Select v-model="formInline.isUse" clearable>
                    <Option
                      v-for="item in isUseList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
          
              <Button type="primary" style="float:right;" @click="handleQuery"
                >查询</Button
              >
              </div>
            </Row>
          </div>
        </Form>
      </div>
      <Table
        border
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <!-- <Button class="table-btn" type="text" size="small" @click="handleDeal(formInline.userType,row.userid)">详情</Button> -->
          <span
            class="pointer"
            v-if="row.isUse == 1"
            type="text"
            size="small"
            @click="handleChange(row)"
            style="margin-right: 12px;"
            >修改</span
          >
            <span
            class="pointer"
             v-if="row.isUse == 1"
            type="text"
            size="small"
            @click="handleResetPassword(row)"
            style="margin-right: 12px;"
            >重置密码</span
          >
            <span
            class="pointer"
             v-if="row.isUse == 1"
            type="text"
            size="small"
            @click="handleUser(0,row)"
            style="margin-right: 12px;"
            >冻结</span
          >
              <span
            class="pointer"
             v-if="row.isUse == 0"
            type="text"
            size="small"
            @click="handleUser(1,row)"
            style="margin-right: 12px;"
            >恢复</span
          >
          <span
            class="pointer"
            type="text"
            size="small"
            @click="handleDelete(row.id)"
            >删除</span
          >
        </template>
      </Table>
      <div class="t-page">
        <Page
          :total="totalCount"
          :page-size="pageSize"
          :current="page"
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
          show-elevator
          show-sizer
          show-total
          transfer
        >
        </Page>
      </div>
    </div>
    <Modal
      v-model="modal"
      width="700"
      title="添加用户"
      @on-cancel="
        () => {
          this.$refs.addUserForm.resetFields();
          this.curRow = null;
        }
      "
    >
      <Form
        ref="addUserForm"
        :model="addUserForm"
        :rules="ruleInline"
        inline
        :label-width="100"
        footer-hide
      >
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="用户姓名:" prop="name">
              <Input
                type="text"
                v-model="addUserForm.name"
                placeholder="用户姓名"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="登录用户名:" prop="account">
              <Input
                type="text"
                v-model="addUserForm.account"
                placeholder="登录用户名"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row :gutter="16">
                    <Col span="12">
                        <FormItem label="密码:">
                            <Input type="text" v-model="addUserForm.password" placeholder="密码"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="确认密码:">
                            <Input type="text" v-model="addUserForm.user3" placeholder="确认密码"></Input>
                        </FormItem>
                    </Col>
                </Row> -->
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="部门:" prop="deptName">
              <Input
                type="text"
                v-model="addUserForm.deptName"
                placeholder="部门"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="用户角色:" prop="roleId">
              <Select v-model="addUserForm.roleId" style="width: 186px">
                <Option
                  v-for="item in roleList"
                  :value="item.id + ''"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="行政区划:" prop="tenantAreaCode">
              <Select
                v-if="area && area.length && area[0].value != '000000'"
                v-model="addUserForm.tenantAreaCode"
                style="width: 186px"
                @on-change="areaChange"
              >
                <Option
                  v-for="item in area"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
              <place-select
                v-model="addUserForm.tenantAreaCode"
                v-else
              ></place-select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="处室/机构:">
              <Input
                type="text"
                v-model="addUserForm.organization"
                placeholder="处室/机构"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="添加人:">
              <Input
                type="text"
                v-model="addUserForm.createrName"
                disabled
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="添加时间:">
              <Input
                type="text"
                v-model="addUserForm.createTime"
                disabled
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="asyncOK" type="primary">提交</Button>
      </div>
    </Modal>
     <Modal
        v-model="passWordModal"
        title="提示"
        @on-ok="okPassword"
        @on-cancel="cancelPassword">
        <p>您的密码重置为{{msg}}</p>
       
    </Modal>
  </div>
</template>

<script>
import tableMixin from "@/components/tableMixin";
// import { mapGetters } from "vuex";
// import { mapState } from "vuex";
import {passwordReset,setUserUseData} from '@/api/platform.js';
export default {
  mixins: [tableMixin],
  data() {
    return {
      passWordModal:false,//重置密码显示的model
      msg:'',//密码提示
      roleList: [],
      showSelect: false,
      addUserForm: {
        roleId: "",
        tenantAreaCode: "",
        name: "",
        account: "",
        password: "111111",
        createrName: localStorage.getItem("userName"),
        createTime: "",
        deptName: "",
        organization: "",
        tenantAreaName: "",
      },
      // 状态用户
         isUseList: [
        { value: '-1', name: '全部' },
        {
          value: '1',
          name: '正常',
        },
        {
          value: '0',
          name: '冻结',
        },
      ],
      modal: false,
      formInline: {
        userType: "tenant",
        userName: "",
        accountName: "",
        areaCode: "",
        isUse:'-1'
      },
        isUserObj:{
        0:'冻结',
        1:'正常'
      },
      tableData: [],
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "登录用户名",
          key: "account",
          minWidth: 100,
          ellipsis: true,
        },
        // {
        //     title: '手机号',
        //     key: 'mobile',
        //     minWidth: 100,
        //     ellipsis: true,
        // },
        {
          title: "姓名",
          key: "name",
          minWidth: 100,
        },
        {
          title: "行政区划",
          minWidth: 100,
          key: "tenantAreaName",
        },
        {
          title: "部门",
          minWidth: 100,
          key: "deptName",
        },
        {
          title: "角色名称",
          minWidth: 100,
          key: "roleName",
        },

        {
          title: "添加时间",
          minWidth: 150,
          key: "createTime",
          align: "left",
        },
        {
          title: '状态',
          key: 'isUse',
          // fixed:'right',
          width: 100,
          render: (h,params) =>{
            return h('span',{},this.isUserObj[params.row.isUse])
            
          }
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          // fixed:'right',
          width: 200,
        },
      ],
      ruleInline: {
        // userType: [
        //     { required: true,  message: '用户类型不能为空', trigger: 'change' }
        // ],
        // account: [
        //     { required: true, validator: validateLogin, trigger: 'blur' },
        //     { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '手机号不正确', trigger: 'change' },
        // ],
        name: [
          { required: true, message: "用户姓名不能为空", trigger: "blur" },
        ],
        account: [
          { required: true, message: "登录用户名不能为空", trigger: "blur" },
        ],
        // password: [
        //     { required: true,validator: validatePass, trigger: 'blur' }
        // ],
        // passwdCheck: [
        //     { required: true, validator: validatePassCheck, trigger: 'blur' }
        // ],
        // tenantAreaCodeS: [
        //     { required: true, type:'array', min: 1, message: '行政区划不能为空', trigger: 'change' }
        // ],
        deptName: [
          { required: true, message: "部门不能为空", trigger: "blur" },
        ],
        // tenantId: [
        //     { required: true, type:'number',  message: '处室/机构不能为空', trigger: 'change' }
        // ],
        roleId: [
          { required: true, message: "用户角色不能为空", trigger: "change" },
        ],
        tenantAreaCode: [
          { required: true, message: "行政区划不能为空", trigger: "change" },
        ],
        // organization: [
        //     { required: true,  message: '处室/机构不能为空', trigger: 'blur' }
        // ],
        // linkPerson: [
        //     { required: true, type:'string',  message: '联系人不能为空', trigger: 'blur' }
        // ],
        // linkPersonTel: [
        //     { required: true, type:'string',  message: '联系电话不能为空', trigger: 'blur' }
        // ],
        // idCardNumber: [
        //     { required: true, type:'string',  message: '身份证号不能为空', trigger: 'blur' }
        // ],
      },
      areaName: "", //县区的时候显示
    };
  },
  computed: {
    // ...mapGetters(["permissions"]),
    // ...mapState(["citys", "users", "area"]),
    // tableColumns(){
    //     let colums=[];
    //     switch (this.formInline.userType) {
    //         case 'tenant':
    //             colums= [
    //                 {
    //                     title: '序号',
    //                     type: 'index',
    //                     width: 70,
    //                     fixed:'left',
    //                     align: 'center'
    //                 },
    //                 {
    //                     title: '账户',
    //                     key: 'account',
    //                     minWidth: 100,
    //                     ellipsis: true,
    //                 },
    //                 {
    //                     title: '姓名',
    //                     key: 'username',
    //                     minWidth:100
    //                 },
    //                 {
    //                     title: '性别',
    //                     key: 'gender',
    //                     minWidth:80,
    //                     render: (h, params) => {
    //                         let str='';
    //                         switch (params.row.gender) {
    //                             case 0:
    //                                 str='未知';
    //                                 break;
    //                             case 1:
    //                                 str='男';
    //                                 break;
    //                             case 2:
    //                                 str='女';
    //                                 break;
    //                             default:
    //                                 break;
    //                         }
    //                         return h('span', str);
    //                     }
    //                 },
    //                 {
    //                     title: '职位',
    //                     minWidth:100,
    //                     key: 'displayposition'
    //                 },
    //                 {
    //                     title: '角色名称',
    //                     minWidth:100,
    //                     key: 'roleName'
    //                 },
    //                 {
    //                     title: '省',
    //                     minWidth:100,
    //                     key: 'province'
    //                 },
    //                 {
    //                     title: '市区',
    //                     minWidth:80,
    //                     key: 'city'
    //                 },
    //                 {
    //                     title: '区县',
    //                     minWidth:80,
    //                     key: 'district'
    //                 },
    //                 {
    //                     title: '部门',
    //                     key: 'deptName',
    //                     minWidth:150
    //                 },
    //                 {
    //                     title: '操作',
    //                     slot: 'action',
    //                     align: 'center',
    //                     // fixed:'right',
    //                     width:80
    //                 }
    //             ];
    //             if(this.permissions.management!=='manage'){
    //                 colums.pop();
    //             }
    //             break;
    //         case 'sublet':
    //             colums= [
    //                 {
    //                     title: '序号',
    //                     type: 'index',
    //                     width: 70,
    //                     fixed:'left',
    //                     align: 'center'
    //                 },
    //                 {
    //                     title: '登录用户名',
    //                     key: 'account',
    //                 },
    //                 {
    //                     title: '企业名称',
    //                     key: 'corpName'
    //                 },
    //                 {
    //                     title: '注册属地',
    //                     key: 'corpAddress'
    //                 },
    //                 {
    //                     title: '联系人',
    //                     key: 'linkPerson'
    //                 },
    //                 {
    //                     title: '联系电话',
    //                     key: 'linkPersonTel'
    //                 },
    //                 {
    //                     title: '用户角色',
    //                     key: 'roleName'
    //                 },
    //                 {
    //                     title: '添加时间',
    //                     key: 'createTime'
    //                 },
    //                 {
    //                     title: '操作',
    //                     slot: 'action',
    //                     align: 'center',
    //                     fixed:'right',
    //                     width:80
    //                 }
    //             ];
    //             break;
    //         case 'project':
    //             colums= [
    //                 {
    //                     title: '序号',
    //                     type: 'index',
    //                     width: 70,
    //                     fixed:'left',
    //                     align: 'center'
    //                 },
    //                 {
    //                     title: '登录用户名',
    //                     key: 'account',
    //                 },
    //                 {
    //                     title: '用户姓名',
    //                     key: 'name'
    //                 },
    //                 {
    //                     title: '身份证号',
    //                     key: 'idCardNumber'
    //                 },
    //                 {
    //                     title: '用户角色',
    //                     key: 'roleName'
    //                 },
    //                 {
    //                     title: '添加时间',
    //                     key: 'createTime'
    //                 },
    //                 {
    //                     title: '操作',
    //                     slot: 'action',
    //                     align: 'center',
    //                     fixed:'right',
    //                     width:80
    //                 }
    //             ];
    //             break;
    //     }

    //     return colums;
    // }
  },
  created() {
    // console.log(999, this.area);
    // if (this.area.length == 1 && this.area[0].children.length == 0) {
    //   this.showSelect = true;
    //   this.areaName = this.area[0].label;
    //   this.formInline.areaCode = this.area[0].value;
    // } else {
    //   this.showSelect = false;
    // }
  },
  mounted() {
    this.getDictCode();
    this.getRoleList();
    this.addUserForm.createTime = this.getTime();
  },
  watch: {},
  methods: {
    getDictCode() {
      const areaCode = localStorage.getItem('tenantAreaCode')
      this.axios({
        method: "get",
        url: "/dict/area/" + areaCode,
      })
        .then((response) => {
          this.area = response.data.data;
          if (this.area.length == 1 && this.area[0].children.length == 0) {
            this.showSelect = true;
            this.areaName = this.area[0].label;
            this.formInline.areaCode = this.area[0].value;
          } else {
            this.showSelect = false;
          }
        })
        .catch(() => {});
    },
    showModal() {
      this.addUserForm = {
        roleId: "",
        tenantAreaCode: "",
        name: "",
        account: "",
        password: "",
        createrName: localStorage.getItem("userName"),
        createTime: this.getTime(),
        deptName: "",
        organization: "",
        tenantAreaName: "",
      };
      this.modal = true;
    },
       //重置密码
    // eslint-disable-next-line no-dupe-keys
    handleResetPassword(row){
      let params={
        userId:row.id
      };
            this.$Modal.confirm({
            title: '提示',
            content: '确认要重置密码吗？',
            onOk: () => {
              passwordReset(params).then((res)=>{
                this.msg = res.data.msg;
                this.passWordModal = true;
            })
           }
        })
    },
    //重置密码弹窗的关闭
    okPassword(){
       this.passWordModal = false;
    },
    cancelPassword(){
       this.passWordModal = false;
    },
    areaChange(val) {
      console.log(val);
      this.area.map((item) => {
        if (item.value == val) {
          console.log(item);
          this.addUserForm.tenantAreaName = item.label;
          console.log(this.addUserForm);
        }
      });
    },
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 > 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 10 ? date.getDate() : "0" + date.getDate();
      let hours =
        date.getHours() > 10 ? date.getHours() : "0" + date.getHours();
      let min =
        date.getMinutes() > 10 ? date.getMinutes() : "0" + date.getMinutes();
      let sec =
        date.getMinutes() > 10 ? date.getSeconds() : "0" + date.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec
      );
    },
    asyncOK() {
      this.$refs.addUserForm.validate((valid) => {
        if (valid) {
          if (this.curRow) {
            this.postUserInfo(this.curRow.id);
          } else {
            this.postUserInfo();
          }
        } 
      });
    },
       //启用  禁用 1 恢复 0是冻结
    handleUser(value,row) {
      let param = {
        id: row.id,
        type: value,
      };
      setUserUseData(param).then((res)=>{
         this.getTableData();
      }) 
    },
    postUserInfo(id) {
      console.log(this.addUserForm);
      this.axios({
        method: "post",
        url: "/user/checkUser",
        data: {
          id: id || "",
          account: this.addUserForm.account,
        },
      }).then((response) => {
        if (response.data.data) {
          return this.$Modal.warning({
            title: "提示",
            content: "该用户已存在",
          });
        } else {
          this.axios({
            method: "post",
            url: this.addUserForm.id ? "/user/updateUser" : "/user/addUser",
            data: id
              ? {
                  id,
                  ...this.addUserForm,
                }
              : this.addUserForm,
          }).then((response) => {
            console.log(response);
            this.modal = false;
            this.getTableData();
          });
        }
      });
    },
    cancel() {
      this.modal = false;
    },
    getRoleList() {
      this.axios({
        method: "get",
        url: "/role/getRoles",
        params: {
          loginType: "tenant",
        },
      }).then((response) => {
        console.log(response);
        if (response.data.success) {
          this.roleList = response.data.data;
        }
      });
    },
    handleChange(row) {
      this.modal = true;
      this.curRow = JSON.parse(JSON.stringify(row));
      this.curRow.roleId = String(this.curRow.roleId);
      this.addUserForm = this.curRow;
    },
    // 删除
    handleDelete(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认删除该条吗？",
        onOk: () => {
          this.$Message.loading({
            content: "正在删除...",
            duration: 0,
          });
          this.axios({
            method: "delete",
            url: `/user/delById/${id}?userType=${this.formInline.userType}`,
          })
            .then((response) => {
              this.$Message.destroy();
              if (response.data.success) {
                this.$Message.success("删除成功!");
                this.getTableData();
              } else {
                this.$Message.warning(response.data.message);
              }
            })
            .catch(() => {
              this.$Message.destroy();
            });
        },
      });
    },
    /*处理操作*/
    handleDeal(type, uuid) {
      let name = "";
      switch (type) {
        case "tenant":
          name = "userManageForm";
          break;
        case "sublet":
          name = "subletManageForm";
          break;
        case "project":
          name = "projectManageForm";
          break;
      }
      this.$router.push({
        name: name,
        query: {
          id: uuid,
          userType: this.formInline.userType,
        },
      });
    },
    /*获取表格数据*/
    getTableData() {
      let param = {
        size: this.pageSize,
        current: this.page,
      };
      Object.assign(param, this.formInline);
      if (this.formInline.areaCode == "") {
        param.areaCode = localStorage.getItem("tenantAreaCode");
      } else {
        param.areaCode = this.formInline.areaCode;
      }
      param.isUse = param.isUse == -1 ?'':param.isUse;
      this.tableData = [];
      this.loading = true;
      this.axios({
        method: "get",
        url: "/user/queryList",
        params: param,
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
